import { WarehouseRestockStatus } from '../enums/warehouse-restock-status';
import { WarehouseRestockType } from '../enums/warehouse-restock-type';
import { Guid, Nillable } from '@web/utils';
import { OrderNumber } from '@web/shared/module/shop';

export class WarehouseRestockCollectionItem {
  public constructor(
    private readonly data: {
      canBeApproved: boolean;
      canBeEdited: boolean;
      canBeRejected: boolean;
      canBeViewed: boolean;
      createdAt: Date;
      id: Guid;
      number: string;
      personDignity?: Nillable<string>;
      personEmail?: Nillable<string>;
      personPhone?: Nillable<string>;
      restockedAt: Date;
      shippingNumber?: Nillable<string>;
      status: WarehouseRestockStatus;
      type: WarehouseRestockType;
      orderNumber: Nillable<OrderNumber>;
      orderId: Nillable<Guid>;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeViewed(): boolean {
    return this.data.canBeViewed;
  }

  public get canBeApproved(): boolean {
    return this.data.canBeApproved;
  }

  public get canBeRejected(): boolean {
    return this.data.canBeRejected;
  }

  public get number(): string {
    return this.data.number;
  }

  public get personDignity(): Nillable<string> {
    return this.data.personDignity;
  }

  public get personEmail(): Nillable<string> {
    return this.data.personEmail;
  }

  public get personPhone(): Nillable<string> {
    return this.data.personPhone;
  }

  public get restockedAt(): Date {
    return this.data.restockedAt;
  }

  public get shippingNumber(): Nillable<string> {
    return this.data.shippingNumber;
  }

  public get status(): WarehouseRestockStatus {
    return this.data.status;
  }

  public get type(): WarehouseRestockType {
    return this.data.type;
  }

  public get orderId(): Nillable<Guid> {
    return this.data.orderId;
  }

  public get orderNumber(): Nillable<OrderNumber> {
    return this.data.orderNumber;
  }
}
